<template>
  <div>
    <v-tabs v-model="tab" class="tabWithoutSlideIndicator">
      <v-tab v-if="this.game.state == 'created' && showTeams" :key="'teams'" :href="`#tab-teams`">{{$t('gameoverview.tab.teams')}}</v-tab>
      <v-tab :key="'schedules'" :href="`#tab-schedules`" v-if="showSchedules">{{$t('gameoverview.tab.game-schedule')}}</v-tab>
      <v-tab :key="'chat'" :href="`#tab-chat`" v-if="showChat">
        <v-badge
            color="accent"
            :value="game.yourUnreadChatMessages ? game.yourUnreadChatMessages > 0 : false"
            :content="''+game.yourUnreadChatMessages"
        >{{$t('gameoverview.tab.chat')}}</v-badge>
      </v-tab>
      <v-tab :key="'info'" :href="`#tab-info`">{{$t('gameoverview.tab.info')}}</v-tab>
      <v-tab v-if="this.game.state != 'created' && showTeams" :key="'teams'" :href="`#tab-teams`">{{$t('gameoverview.tab.teams')}}</v-tab>
      <v-tab :key="'participants'" :href="`#tab-participants`">{{$t('gameoverview.tab.participants')}}</v-tab>
      <v-tab :key="'settings'" :href="`#tab-settings`" v-if="showSettings">{{$t('gameoverview.tab.settings')}}</v-tab>

      <v-tab-item :value="'tab-schedules'" v-if="showSchedules">
        <div v-if="this.game.state == 'created' || this.game.state == 'checkin'">
          <game-info :game="game" :showDescription="false" :showLegal="false"/>
        </div>
        <schedule v-else :game="game" />
      </v-tab-item>
      <v-tab-item :value="'tab-chat'" v-if="showChat">
        <chat :game="game" :active="tab == 'tab-chat'" />
      </v-tab-item>
      <v-tab-item :value="'tab-info'">
        <game-info :game="game" :showGameAndPlatform="true"/>
      </v-tab-item>
      <v-tab-item :value="'tab-teams'">
        <team-list :game="game"/>
      </v-tab-item>
      <v-tab-item :value="'tab-participants'">
        <participants :game="game" />
      </v-tab-item>
      <v-tab-item :value="'tab-settings'" v-if="showSettings">
        <game-settings :game="game" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import {} from "@/plugins/store";
import { EVENT_REFRESH_DATA } from "@/plugins/eventbus";
import Schedule from "@/widgets/Schedule";
import Participants from "@/widgets/Participants";
import GameInfo from "@/widgets/GameInfo";
import GameSettings from "@/widgets/GameSettings";
import Chat from "@/widgets/Chat";
import TeamList from "@/widgets/TeamList"
import gameModeMixin from "@/mixins/gameModeMixin"

export default {
  name: "KoMixedGameOverview",
  mixins: [gameModeMixin],
  components: {
    Schedule,
    Participants,
    GameInfo,
    GameSettings,
    Chat,
    TeamList,
  },
  props: {
    game: {
      type: Object,
      required: true
    },
    tabKey: {
      type: String,
      required: false
    },
    disableRouting: {
      type: Boolean,
      default: false
    },
    hideChat: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      tab: undefined
    };
  },
  computed: {
    showTeams: function() {
      return this.gameModeIsAnyTeamMode(this.game.mode)
    },
    showSettings: function() {
      return this.game.youAreAdmin == true;
    },
    showSchedules: function() {
      return true; // this.game.state != 'created' && this.game.state != 'checkin'
    },
    showChat: function() {
      return this.hideChat == false && this.game.chatUid !== null;
    },
  },
  watch: {
    game: function() {
      console.log("game changed");
      this.reset();
    },
    tabKey: function() {
      this.tab = "tab-" + this.tabKey;
    },
    tab: function(val) {
      if (val && this.disableRouting == false) {
        let key = val.substring(4);
        if (this.$route.query.tab != key) {
          console.log("tab changed to", key);
          this.$router.replace({ query: { ...this.$route.query, tab: key } }).catch(() => {
            // Ignore NavigationDuplicated
          });
        }
      }
    }
  },
  mounted() {
    this.tab = "tab-" + this.tabKey;
    this.$eventBus.$on(EVENT_REFRESH_DATA, this.onRefreshData);
  },
  beforeDestroy() {
    this.$eventBus.$off(EVENT_REFRESH_DATA, this.onRefreshData);
  },

  methods: {
    onRefreshData() {},
    reset() {}
  }
};
</script>

<style scoped>
.tabWithoutSlideIndicator >>> .v-slide-group__prev {
  display: none !important;
}
</style>
